var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.214,
    height: 21.214,
    viewBox: "0 0 21.214 21.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-unlink",
    "data-name": "Icon awesome-unlink",
    d: "M12.6,16.818a.5.5,0,0,1,0,.7l-1.851,1.851a6.3,6.3,0,0,1-8.907-8.906L3.693,8.615a.5.5,0,0,1,.7,0l1.641,1.641a.5.5,0,0,1,0,.7L4.185,12.809A2.983,2.983,0,0,0,8.4,17.028l1.851-1.851a.5.5,0,0,1,.7,0ZM10.255,6.036a.5.5,0,0,0,.7,0l1.851-1.851A2.983,2.983,0,0,1,17.028,8.4l-1.851,1.851a.5.5,0,0,0,0,.7L16.818,12.6a.5.5,0,0,0,.7,0l1.851-1.851a6.3,6.3,0,0,0-8.907-8.906L8.615,3.693a.5.5,0,0,0,0,.7l1.641,1.641Zm9.73,14.886.938-.938a.994.994,0,0,0,0-1.406L2.635.291a.994.994,0,0,0-1.406,0l-.938.938a.994.994,0,0,0,0,1.406L18.579,20.923a.994.994,0,0,0,1.406,0Z",
    transform: "translate(0 0)",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeUnlink);
export default __webpack_public_path__ + "static/media/Icon awesome-unlink.d85d19af021c876ad51bc82ac661f70a.svg";
export { ForwardRef as ReactComponent };